/**
 * @generated SignedSource<<248a5deea759cf37e230e7038578fe5c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type PerformanceQueryReaderBenchmarkQuery$variables = {};
export type PerformanceQueryReaderBenchmarkQuery$data = {
  readonly clientsummary_viewer: {
    readonly getPortfolioPerformanceBenchmark: ReadonlyArray<{
      readonly asOfDate: any | null;
      readonly benchmarkName: string;
      readonly fiveYearReturns: number | null;
      readonly monthToDate: number | null;
      readonly oneYearReturns: number | null;
      readonly portfolioPerformanceBenchmarkId: number;
      readonly quarterToDate: number | null;
      readonly tenYearReturns: number | null;
      readonly threeYearReturns: number | null;
      readonly yearToDate: number | null;
    }>;
    readonly id: string;
  };
};
export type PerformanceQueryReaderBenchmarkQuery = {
  response: PerformanceQueryReaderBenchmarkQuery$data;
  variables: PerformanceQueryReaderBenchmarkQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ClientSummaryViewer",
    "kind": "LinkedField",
    "name": "clientsummary_viewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PortfolioPerformanceBenchmarkModel",
        "kind": "LinkedField",
        "name": "getPortfolioPerformanceBenchmark",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "asOfDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fiveYearReturns",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "monthToDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "oneYearReturns",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "portfolioPerformanceBenchmarkId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "quarterToDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tenYearReturns",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "threeYearReturns",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "yearToDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "benchmarkName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PerformanceQueryReaderBenchmarkQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PerformanceQueryReaderBenchmarkQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "19b0aee0af912da589eb4ac8da58588b",
    "id": null,
    "metadata": {},
    "name": "PerformanceQueryReaderBenchmarkQuery",
    "operationKind": "query",
    "text": "query PerformanceQueryReaderBenchmarkQuery {\n  clientsummary_viewer {\n    id\n    getPortfolioPerformanceBenchmark {\n      asOfDate\n      fiveYearReturns\n      monthToDate\n      oneYearReturns\n      portfolioPerformanceBenchmarkId\n      quarterToDate\n      tenYearReturns\n      threeYearReturns\n      yearToDate\n      benchmarkName\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d95e05573d50aa6d300e205eef4e738a";

export default node;
